<template>
	<div>
    <h2 class="view__title--sub">{{ L.localize("Campaign_InformationTitle") }}</h2>

    <TextBox
      label="Label_Name"
      v-model="campaign.name"
      :validate="$v.campaign"
      modelPath="name"
      acc="name"

      @input="$v.campaign.name.$touch"
    />

    <TextBox
      label="Campaigns_Subject"
      v-model="campaign.subject"
      :validate="$v.campaign"
      v-on:input="$v.campaign.subject.$touch"
      modelPath="subject"
      acc="subject"

      @input="$v.campaign.subject.$touch"
    />

    <h2 class="view__title--sub">{{ L.localize("Campaign_WhoIsThisFromTitle") }}</h2>

    <TextBox
      label="Label_FromName"
      v-model="campaign.fromName"
      :validate="$v.campaign"
      modelPath="fromName"
      acc="fromName"

      @input="$v.campaign.fromName.$touch"
    />

    <TextBox
      label="Label_FromEmail"
      v-model="campaign.fromEmail"
      :validate="$v.campaign"
      v-on:input="$v.campaign.fromEmail.$touch"
      modelPath="fromEmail"
      acc="fromEmail"

      @input="$v.campaign.fromEmail.$touch"
    />

    <p class="view__infos">{{ L.localize("CAmpaign_WhoIsThisFromText") }}</p>

	</div>
</template>

<script>
import { TextBox } from 'components/layout/forms'
import { Validation } from 'components/helpers'
import { required } from 'vuelidate/lib/validators'
import L from 'services/Localization'

export default {
  name: 'campaign-information',
  components: { Validation, TextBox },
  props: {
    campaign: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      L: L
    }
  },
  validations: {
    campaign: {
      name: { required },
      subject: { required },
      fromName: { required },
      fromEmail: { required }
    }
  },
  methods: {
    isValid() {
      let isValid = true
      if (this.$v.$invalid) {
        this.$v.$touch()
        isValid = false
      }
      return isValid
    }
  }
}
</script>



// WEBPACK FOOTER //
// CampaignInformation.vue?ddde4356